// Generated by `npm run whitetip` (scripts/whitetip.ts), from no archive: Maui Nui's whitetip reef sharks on
// the last day of 2025 in the ages their rates settle into, 1498.33 of every size,
// NOAA's divers' density over Maui Nui's hard bottom; the young's survival a year the one number fitted, so they
// replace themselves; every other figure a source's (src/sim/whitetips.ts). Do not edit by hand.
// tests/whitetip.test.ts builds it again.
import type { TigerSharkState } from '../../types';

/** The young's survival a year, birth to female maturity, fitted so the whitetips replace themselves. */
export const WHITETIP_YOUNG_SURVIVAL = 0.8119011;

/** The factor the whitetips grow by a year at their rates, their ages settled. */
export const WHITETIP_GROWTH = 1.0000000;

/** The whitetips on the year before's last day (expected values; a world opening rounds them), by year class since birth. */
export const WHITETIP_TABLE: TigerSharkState = {
  counts: [234.959, 190.764, 154.881, 125.748, 102.095, 82.8911, 67.2994, 54.6405, 48.0901, 44.5038, 41.1851, 38.1138, 35.2715, 32.6412, 30.2071, 27.9544, 25.8698, 23.9406, 22.1553, 20.5031, 18.9741, 17.5592, 16.2497, 15.0379, 13.9165, 12.8787],
};
